<div
  [ngClass]="frame?.rtlEnabled ? 'controlPanelRtl' : 'controlPanel'"
  fxLayout.sm="isWorkListFilterRemoved ? 'row' : 'column'"
  class="responsive-layout"
  [dir]="frame?.rtlEnabled ? 'rtl' : 'auto'"
>
  <div style="padding-top: 5px" fxLayout="row" fxLayoutAlign="start start">
    <table matSort matSortActive="sortOrder" matSortDirection="asc" matSortDisableClear (matSortChange)="sortData()">
      <tr>
        <td class="sortHeader" mat-sort-header="sortOrder">{{ res.get('Work-List-Order') }}</td>
        <td class="sortHeaderGap"></td>
        <td class="sortHeader" mat-sort-header="designation">{{ res.get('Work-List-Designation') }}</td>
        <td class="sortHeaderGap"></td>
        <td class="sortHeader" mat-sort-header="objectType">{{ res.get('Work-List-Type') }}</td>
        <td class="sortHeaderGap"></td>
        <td class="sortHeader" mat-sort-header="objectDesignation">{{ res.get('Work-List-ObjectDesignation') }}</td>
        <td class="sortHeaderGap"></td>
        <td class="sortHeader" mat-sort-header="street">{{ res.get('Work-List-Street') }}</td>
        @if (hasMtObjectNotes) {
          <td class="sortHeaderGap"></td>
          <td class="sortHeader" mat-sort-header="note">{{ res.get('Work-List-Note') }}</td>
        }
      </tr>
    </table>
  </div>
  <div fxLayout="row" fxLayoutAlign="end end">
    <div class="mat-chip-width">
      <mat-chip-listbox>
        @for (filter of dataContext?.dataSource.visibleFilters; track trackById($index, filter)) {
          <mat-chip (removed)="removeFilter(filter)">
            <div style="word-wrap: break-word">
              {{ filter.displayText }}
            </div>
            <mat-icon
              [svgIcon]="res.svgName('Cancel-Image')"
              matChipRemove
              style="width: 25px !important; height: 25px !important"
            ></mat-icon>
          </mat-chip>
        }
      </mat-chip-listbox>
    </div>

    <div
      class="button-group-wrapper"
      [ngStyle.xs]="{ 'margin-left': 'auto' }"
      [ngStyle.sm]="{ 'margin-left': 'auto' }"
      [ngStyle.md]="{ 'margin-left': 'auto' }"
    >
      <dx-button-group
        [items]="workStateButtons"
        [id]="'workListId'"
        keyExpr="id"
        selectionMode="multiple"
        focusStateEnabled="false"
        activeStateEnabled="false"
        [(selectedItemKeys)]="this.selectedWorkStates"
        (onItemClick)="workStateFilterClick($event)"
      >
      </dx-button-group>
      <div class="placeholder-button">
        <!-- Empty div or an icon of the same size to maintain space -->
      </div>
    </div>
  </div>
</div>

<!--normal itemSize="48", but with 60 we enjoy smoother scrolling -->
<cdk-virtual-scroll-viewport
  [dir]="frame?.rtlEnabled ? 'rtl' : 'auto'"
  #workListScrollViewPort
  id="workListScrollViewPort"
  class="workListScrollViewPort consistent-width"
  itemSize="66"
  style="overflow-y: auto; width: 100%"
>
  @if (dataContext?.dataSource.data) {
    <div *cdkVirtualFor="let work of dataContext?.dataSource.internalDataSource; let wIndex = index">
      <!-- templateCacheSize: 0 -->
      @if (mustShowCategoryHeader(work)) {
        <div class="aggregated-category-header">
          {{ work.aggregatedModeCategoryHeaderText }}
        </div>
      }
      <p>
        <mat-card class="workPanel" (click)="work.tasks?.length > 0 ? navigateToWorkDetail(wIndex) : null">
          <table cellpadding="0" cellspacing="0" style="width: 100%">
            <tr style="width: 100%">
              <td [ngStyle]="{ width: frame?.rtlEnabled ? '30px' : '16px' }">
                <mat-icon class="workPanelWorkStateIcon" [svgIcon]="res.svgName(work.stateIconName)"></mat-icon>
              </td>
              <td [ngClass]="work.tasks?.length > 0 ? 'workPanelWorkTitle' : 'workPanelWorkTitleWithEmptyTasks'">
                <div class="work-layout">
                  {{ work.toString() }}
                </div>
              </td>
              @if (!$any(frame.frameConfig.settings.get(AppService.Setting_ShowWorkDetails)).value) {
                <td [ngStyle]="{ 'text-align': frame?.rtlEnabled ? 'left' : 'right' }">
                  @if (!work.isVirtual) {
                    <button mat-button (click)="selectWorkInMap(work); $event.stopPropagation()">
                      <mat-icon class="locateIcon" [svgIcon]="res.svgName('Locate-Image')"></mat-icon>
                    </button>
                  }
                </td>
              }
            </tr>
          </table>
          @if ($any(frame.frameConfig.settings.get(AppService.Setting_ShowWorkDetails)).value) {
            <div class="locate-Image-button-container">
              @if (!work.isVirtual) {
                <button mat-button (click)="selectWorkInMap(work); $event.stopPropagation()">
                  <mat-icon class="locateIcon" [svgIcon]="res.svgName('Locate-Image')"></mat-icon>
                </button>
              }
            </div>
          }
          @if ($any(frame.frameConfig.settings.get(AppService.Setting_ShowWorkDetails)).value) {
            @for (task of work.tasks; track task; let i = $index) {
              <div class="workPanelTaskTitle">
                @if (task.finished) {
                  <mat-icon class="workPanelWorkTasksIcon" [svgIcon]="res.svgName('Done-Image')"></mat-icon>
                }
                <span>
                  {{ task.designation }}
                  @if (i < work.tasks.length - 1) {
                    ,&nbsp;&nbsp;
                  }
                </span>
              </div>
            }
          }
        </mat-card>
      </p>
    </div>
  }
</cdk-virtual-scroll-viewport>
